<template>
  <div class="container">
    <div
      :class="[
        'header',
        !isToggled ? 'border-bottom' : 'cancel-padding-bottom',
      ]"
      @click.prevent="toggle"
    >
      <slot name="title"></slot>
      <div class="toggle-button">
        <div class="img-wrapper">
          <img
            class="img"
            :src="
              isToggled
                ? require('@/assets/imgs/arrow_up_circle.png')
                : require('@/assets/imgs/arrow_down_circle.png')
            "
          />
        </div>
      </div>
    </div>
    <div class="content" v-show="isToggled">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollapsePanel",
  props: {
    toggled: {
      type: Boolean,
      default: false,
    },
    name: String,
  },
  mounted() {
    const toggled = localStorage.getItem(`${this.name}-toggled`);
    if (toggled !== undefined) {
      this.isToggled = !!Number(toggled);
    } else {
      this.isToggled = this.toggled;
    }
  },
  data() {
    return {
      isToggled: this.toggled,
    };
  },
  methods: {
    toggle() {
      const value = !this.isToggled;
      this.isToggled = value;
      if (this.name) {
        localStorage.setItem(`${this.name}-toggled`, Number(value));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/fonts.scss";
@import "../../common/colors.scss";

.container {
  padding: 40px 0 0;
  background: $cod-gray;
  border-radius: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0 0 24px 0;
}

.cancel-padding-bottom {
  padding-bottom: 0;
}

.content {
  padding: 16px 0 0 0;
}

.toggle-button {
  display: flex;
  align-items: center;
}

.border-bottom {
  border-bottom: 1px solid rgba($manatee, 0.2);
}

.img-wrapper {
  margin: 0 0 0 8px;
  width: 16px;
  height: 16px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
